import { useState, useEffect } from "react";
import { useStaticQuery, graphql } from "gatsby";
import babelConfig from "../../babel-config.json";

const serviceBaseUrl = "https://apigateway.candy-group.com/PROD/legacy";

const filterResults = (products) => {
  return products.map((product) => ({
    ...product,
    attributes: product.attributes?.filter(
      (attr) =>
        !(
          attr.category?.id === 1068 &&
          `${attr.id}`.startsWith("99999") &&
          ["", "0"].includes(attr.fieldValue)
        )
    ),
  }));
};

const paginatedFetch = async (baseUrl, pageSize = 100) => {
  let end = pageSize;
  const sizeUrl = `${baseUrl}/0/${end}`;
  const response = await fetch(sizeUrl);
  if (!response.ok) {
    throw new Error(
      `HTTP Error Response: ${response.status} ${response.statusText} for: ${sizeUrl}`
    );
  }
  const data = await response.json();
  const { GetProductsDetailsNewResult = [] } = data;
  if (!Array.isArray(GetProductsDetailsNewResult)) {
    console.error(`Invalid result for ${sizeUrl}: `, data);
    throw new Error(`Invalid result for ${sizeUrl}`);
  }
  let currentResults = GetProductsDetailsNewResult;
  const items = filterResults([...currentResults]);
  while (currentResults.length === pageSize) {
    const start = end;
    end = start + pageSize;
    const pageUrl = `${baseUrl}/${start}/${end}`;
    const response = await fetch(pageUrl);
    if (!response.ok) {
      throw new Error(
        `HTTP Error Response: ${response.status} ${response.statusText} for ${pageUrl}`
      );
    }
    const data = await response.json();
    const { GetProductsDetailsNewResult: newItems } = data;
    if (!Array.isArray(newItems)) {
      console.error(`Invalid result for ${sizeUrl}: `, data);
      throw new Error(`Invalid result for ${sizeUrl}`);
    }
    items.push(...filterResults([...newItems]));
    currentResults = newItems;
  }

  return items;
};

const useBabelModels = (lineId) => {
  const [modelli, setModelli] = useState();

  const {
    site: {
      siteMetadata: { babelPrefix },
    },
  } = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          babelPrefix
        }
      }
    }
  `);

  useEffect(() => {
    if (!lineId) return;
    const serviceLine = `${serviceBaseUrl}/getproductsdetailsnew/${lineId}/${babelPrefix}/haier`;
    const { headAttributes } = babelConfig;
    const productNameAttrId = headAttributes.productName[lineId];
    const loadModelli = async () => {
      setModelli();
      try {
        console.log("serviceLine: ", serviceLine);
        const items = await paginatedFetch(serviceLine, 20);
        const modelliItems = items.map((item) => {
          const modelName =
            item.extraInfo?.ca4_CHG_HAIER_CM && item.extraInfo?.ca4_CHG_MODEL_OWNER === "H"
              ? item.extraInfo?.ca4_CHG_HAIER_CM
              : item.attributes.find((attr) => attr.id === productNameAttrId)?.fieldValue;
          return {
            productName: modelName,
            modelName,
          };
        });
        const filteredModelliItems = (() => {
          const filtered = new Set();
          return modelliItems?.filter(
            (item) => !filtered?.has(item?.productName) && filtered?.add(item?.productName)
          );
        })();

        setModelli(filteredModelliItems);
      } catch (err) {
        console.log("Error loading modelli: ", err);
      }
    };
    loadModelli();
  }, [babelPrefix, lineId]);

  return modelli;
};

export default useBabelModels;
